// extracted by mini-css-extract-plugin
module.exports = {"container":"main-content-container_container__1rdEN"};